<template>
    <app-primary> 
        <template #subHead>
            <sub-visual sh="Contact Us">
                <template #titHead>#</template>
                <template #tit>전국 사무소 안내</template>
            </sub-visual>
        </template>

        <div class="contact-list">
            <sub-contact
                class="contact-item"
                iframe="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3165.644687382891!2d127.00898542635954!3d37.49271027835712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca15e975930fb%3A0x8d8a8696999dee3c!2z7ZWc6rWt7JWE7J2067mE7JeQ7Iqk!5e0!3m2!1sko!2skr!4v1694506474644!5m2!1sko!2skr"
                address="서울시 서초구 서초대로 272, 9층 (한국아이비에스빌딩)"
                image="/images/sub/contact/seoul/seoul-img.jpg" 
                tel="02-523-0522"
            />

            <sub-contact
                class="contact-item"
                iframe="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3174.1517930127693!2d127.06578927635245!3d37.29153613984852!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5b11bd2701bd%3A0xfe8f00df9aabd7ed!2z6rK96riw64-EIOyImOybkOyLnCDsmIHthrXqtawg6rSR6rWQ7KSR7JWZ66GcMjQ467KI6ri4IDk1LTE!5e0!3m2!1sko!2skr!4v1694507999927!5m2!1sko!2skr"
                address="경기도 수원시 영통구 광교중앙로 248번길 95-1, 7층 (광교법조타운)"
                image="/images/sub/contact/suwon/suwon-img.jpg"
                tel="031-213-0522"
            />

            <sub-contact
                class="contact-item"
                iframe="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d791.9492321630047!2d126.66685616964966!3d37.44190176305178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b79a416b78189%3A0x3984c891254cf627!2z7J247LKc6rSR7Jet7IucIOuvuOy2lO2ZgOq1rCDshozshLHroZwgMTcx!5e0!3m2!1sko!2skr!4v1701928629137!5m2!1sko!2skr"
                address="인천 미추홀구 소성로 171 대흥평창로시스빌딩 로시스동 3층"
                image="/images/sub/contact/incheon/incheon-img.jpg"
            />

            <sub-contact
                class="contact-item"
                iframe="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3233.4804225545263!2d128.62319307721492!3d35.861741920034696!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3565e2249622726f%3A0x265c1074a886d783!2z64yA6rWs6rSR7Jet7IucIOyImOyEseq1rCDrj5nrjIDqtazroZwgMzQ1!5e0!3m2!1sko!2skr!4v1730456124946!5m2!1sko!2skr"
                address="대구 수성구 동대구로 345 우방유쉘상가동 2층 206호"
                image="/images/sub/contact/incheon/daegu-img.jpg"
            />
        </div>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubVisual from "@/sets/styles/sub/sub-visual.vue";
import PageSection from "@/sets/styles/pages/page-section.vue";
import SubContact from "@/sets/styles/sub/sub-contact.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTitMedium from "@/components/publish/styles/typography/u-tit-medium.vue";

export default {
    components: {
        AppPrimary,
        SubVisual,
        PageSection,
        SubContact,
        UTxtDefault,
        UTxtMedium,
        UTitDefault,
        UTitMedium,
    },
};
</script>

<style lang="scss" scoped>
.contact-list {
    display: flex;
    flex-direction: column;
    gap: 2rem; /* 각 지점 간 간격 */
    padding: 1rem 0;
}

.contact-item {
    padding: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fafafa;
}
</style>
